/**
 * Disable browser console output for public builds (backup if compile-time strip misses a file).
 * - Default: strip (quiet console).
 * - Opt-in to logs: `localStorage.setItem('S2R_DEBUG_CONSOLE','1'); location.reload()`
 * - Or set STRIP_BROWSER_CONSOLE=false in .env and rebuild.
 * Loaded before other app modules from surprise-bootstrap.js.
 */
;(function () {
  if (typeof window === 'undefined') return
  try {
    if (window.localStorage && window.localStorage.getItem('S2R_DEBUG_CONSOLE') === '1') {
      return
    }
  } catch (_) {}
  let strip = true
  try {
    strip = String(process.env.STRIP_BROWSER_CONSOLE || 'true').toLowerCase() !== 'false'
  } catch (_) {
    strip = true
  }
  if (!strip) return

  const noop = function () {}
  const keys = [
    'log',
    'info',
    'debug',
    'warn',
    'error',
    'trace',
    'dir',
    'dirxml',
    'table',
    'group',
    'groupCollapsed',
    'groupEnd',
    'time',
    'timeEnd',
    'timeLog',
    'count',
    'assert',
    'clear'
  ]

  const c = window.console
  if (!c) return

  for (let i = 0; i < keys.length; i++) {
    const k = keys[i]
    try {
      const desc = Object.getOwnPropertyDescriptor(c, k)
      if (desc && desc.configurable === false) {
        try {
          Object.defineProperty(c, k, {
            value: noop,
            writable: true,
            configurable: true,
            enumerable: desc.enumerable
          })
        } catch (_) {
          try {
            c[k] = noop
          } catch (_) {}
        }
      } else {
        try {
          c[k] = noop
        } catch (_) {
          try {
            Object.defineProperty(c, k, {
              value: noop,
              writable: true,
              configurable: true,
              enumerable: true
            })
          } catch (_) {}
        }
      }
    } catch (_) {}
  }
})()
